import z from "zod";
import { api } from "_shared/_stores/api";
import { logSchemaFailure } from "_shared/_utilities/log-schema-failure";
import {
  TemplateUsageJSON,
  TemplateUsageJSONZ,
  TemplateUsageKind,
} from "work/template-usages/_schemas/template-usage-schema";

/**
 * The proposals and work built from one template that the reader can see (#2401).
 *
 * A list, so work the reader may not see is left out rather than refused. The template itself is
 * refused with a 403 and is absent with a 404.
 */
export const templateUsagesApi = api.injectEndpoints({
  endpoints: (build) => ({
    getTemplateUsages: build.query<TemplateUsageJSON[], { kind: TemplateUsageKind; templateId: string }>({
      query: ({ kind, templateId }) => `work/${kind}/${templateId}/usages`,
      rawResponseSchema: z.array(TemplateUsageJSONZ),
      onSchemaFailure: logSchemaFailure,
      // The rows are proposals and work, so the list refetches whenever those lists do. The Ably
      // middlewares invalidate both LIST tags on every proposal and work agreement change, and a
      // stage or a new usage would otherwise wait for the panel to be closed and opened again.
      // The per-row tags catch an invalidation aimed at one agreement or one proposal.
      providesTags: (result) => [
        { type: "Proposal" as const, id: "LIST" },
        { type: "WorkAgreement" as const, id: "LIST" },
        ...(result ?? []).flatMap((usage) => [
          { type: "Proposal" as const, id: usage.proposalId },
          { type: "WorkAgreement" as const, id: usage.workAgreementId },
        ]),
      ],
    }),
  }),
});

export const { useGetTemplateUsagesQuery } = templateUsagesApi;
